import ApiService from '../api.service';

const StudentOccurrences = {
  index: (params) => ApiService.query('/api/v2/teachers/me/student_occurrences', params),
  update: (params) => ApiService.put(`/api/v2/teachers/me/student_occurrences/${params.student_id}`, params),
};

export default StudentOccurrences;
